<vrm-dialog-header
  [dialogTitle]="title"
  [hideDivider]="true"
  [showPrint]="true"
  [printFileName]="printFileName"
  [isLarge]="true"
></vrm-dialog-header>

<div class="body" [dir]="commonService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">

  <!-- Licence Summary -->
  <div class="section">
    <vrm-driver-licence-summary [dataSource]="summary$ | async"></vrm-driver-licence-summary>
  </div>

  <!-- Endorsements Table -->
  <div class="section">
    <vrm-licence-endorsements-table [dataSource]="endorsements$ | async"></vrm-licence-endorsements-table>
  </div>

  <!-- Full Entitlements -->
  <div class="section">
    <vrm-licence-entitlements-table
      [licenceType]="'LICENCE_CHECKING.fullEntitlements' | translateOrFallback:'Full Entitlements'"
      [dataSource]="fullEntitlements$ | async"
    ></vrm-licence-entitlements-table>
  </div>

  <!-- Provisional Entitlements -->
  <div class="section">
    <vrm-licence-entitlements-table
      [licenceType]="'LICENCE_CHECKING.provisionalEntitlements' | translateOrFallback:'Provisional Entitlements'"
      [dataSource]="provisionalEntitlements$ | async"
    ></vrm-licence-entitlements-table>
  </div>

  <!-- Restriction Codes -->
  <div class="section">
    <vrm-licence-restrictions-table [dataSource]="restrictionCodes$ | async"></vrm-licence-restrictions-table>
  </div>
</div>
